module.exports = __webpack_public_path__ + "static/media/034-uranus.30b18de4.svg";